import { render, staticRenderFns } from "./DxpPage.vue?vue&type=template&id=61630cc7&scoped=true"
import script from "./DxpPage.vue?vue&type=script&lang=js"
export * from "./DxpPage.vue?vue&type=script&lang=js"
import style0 from "./DxpPage.vue?vue&type=style&index=0&id=61630cc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61630cc7",
  null
  
)

export default component.exports